import type { Component } from 'solid-js'
import type { EventsTimeSeriesData } from '../../../features/engagement/domain/models/events'
import { ChartContainer, ChartLegend, useChartWithLegend, useLegendState } from '../charts'
import { getEventsChartOptions, EVENTS_LEGEND_ITEMS, EVENTS_INITIAL_LEGEND_STATE } from './EventsChart.vm'

interface EventsChartProps {
  data: EventsTimeSeriesData[]
}

const EventsChart: Component<EventsChartProps> = (props) => {
  let chartRef: HTMLDivElement | undefined

  const { state: legendState, toggle } = useLegendState(EVENTS_INITIAL_LEGEND_STATE)

  useChartWithLegend({
    data: () => props.data,
    chartRef: () => chartRef,
    legendState,
    buildOptions: (data, legend) => getEventsChartOptions(data, legend)
  })

  return (
    <ChartContainer hasData={props.data && props.data.length > 0}>
      <ChartLegend items={EVENTS_LEGEND_ITEMS} activeKeys={legendState()} onToggle={toggle} class="mb-4" />
      <div ref={chartRef} />
    </ChartContainer>
  )
}

export default EventsChart
